import type { Conversation, PublicUser } from '@sirocco/shared';
import { Avatar } from '../../components/ui/Avatar';
import { Sheet, SheetAction } from '../../components/ui/Sheet';
import { t } from '../../i18n';

/**
 * Un groupe ne reste jamais sans administrateur.
 *
 * Ses pouvoirs — retirer quelqu'un, nommer un successeur — n'appartiennent
 * qu'a lui. Partir en les emportant laisserait un groupe que personne ne
 * peut plus ranger : la sortie passe donc d'abord par cette feuille, d'ou
 * qu'on la demande — la fiche du groupe ou la liste des conversations.
 */

/**
 * Ce depart laisserait-il le groupe sans chef.
 *
 * Deux cas, et la meme reponse : je suis l'administrateur, ou le groupe
 * n'en a plus. Le second existe pour de vrai — les groupes d'avant cette
 * regle ont pu voir leur admin s'en aller. Le prochain qui sort les
 * repare.
 */
export function needsSuccessor(conversation: Conversation, uid: string | undefined): boolean {
  if (conversation.type !== 'group') return false;
  if (conversation.members.length < 2) return false;
  return !conversation.adminId || conversation.adminId === uid;
}

export function HandOverSheet({
  open,
  members,
  meId,
  orphan,
  onClose,
  onPick,
}: {
  open: boolean;
  members: PublicUser[];
  meId: string | undefined;
  /** Le groupe n'avait deja plus d'admin : la question n'est pas la meme. */
  orphan: boolean;
  onClose: () => void;
  onPick: (member: PublicUser) => void;
}) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title={orphan ? t.messages.passation.orphelin : t.messages.passation.laisser}
    >
      {members
        .filter((member) => member.id !== meId)
        .map((member) => (
          <SheetAction
            key={member.id}
            icon={<Avatar user={member} size={26} />}
            onClick={() => onPick(member)}
          >
            {member.username}
          </SheetAction>
        ))}
    </Sheet>
  );
}
